import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import {Helmet} from "react-helmet";
import Navigation from './navigation';
import Footer from './footer';
import Hero from './assets/hero-2.svg';
import MobileHero from './assets/hero-mobile.svg';
import Matt from './assets/matt-aidem.png';
import Aaron from './assets/aaron.png';
import Daniel from './assets/daniel.png';
import Frances from './assets/frances.png';
import Write from './assets/write.png';
import Media from './assets/media-outlets-prod.svg';
import Rumblr from './assets/rumblr.png';
import Users from './assets/howler-users.svg';


class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }



  render() {
    console.log(this.state.width);

    return (
      <div>
        <Helmet>

          <title>Howler: Get more press with AI-powered PR 🚀</title>
          <meta name="description" content="Use Howler AI to run automated PR campaigns to thousands of relevant journalists in your niche. Every campaign comes with a custom media list of hyper-targeted journalists." />

          <meta itemprop="name" content="Howler: Get more press with AI-powered PR 🚀" />
          <meta itemprop="description" content="Use Howler AI to run automated PR campaigns to thousands of relevant journalists in your niche. Every campaign comes with a custom media list of hyper-targeted journalists." />
          <meta itemprop="image" content="https://i.imgur.com/0IDeqko.png" />

          <meta property="og:url" content="https://www.howler.media" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Howler: Get more press with AI-powered PR 🚀" />
          <meta property="og:description" content="Use Howler AI to run automated PR campaigns to thousands of relevant journalists in your niche. Every campaign comes with a custom media list of hyper-targeted journalists." />
          <meta property="og:image" content="https://i.imgur.com/0IDeqko.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Howler: Get more press with AI-powered PR 🚀" />
          <meta name="twitter:description" content="Use Howler AI to run automated PR campaigns to thousands of relevant journalists in your niche. Every campaign comes with a custom media list of hyper-targeted journalists." />
          <meta name="twitter:image" content="https://i.imgur.com/0IDeqko.png" />

        </Helmet>

        <Navigation />
        { this.state.width > 900 ? <img
          src={ Hero }
          className="is-overlay"
        /> : <img
          src={ MobileHero }
          className="is-overlay"
        />}

        <section className="section has-bg-image is-centered has-text-centered" style={{ height: "28em" }}>
          <div className="columns">
            <div className="column">
              <div className="container is-overlay has-padding-bottom has-text-centered">
                <div className="hero-div-width">
                  <h1 className="title has-text-white has-text-weight-bold is-hero-title is-size-2">
                    Use Howler to run automated PR campaigns to relevant journalists in your niche 🚀
                  </h1>
                   <br />
                </div>

                <AnchorLink href="#howitworks" className={ this.state.isActive ? 'button is-hiw-hero' : 'button is-hiw-hero'}>How it works</AnchorLink>
                <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
                <p className="has-text-white is-size-6 is-hero-sub">
                  Match with thousands of journalists from our database of 600k, powered by AI
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns has-text-centered is-centered">
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  🤑
                </div>
                <div className="title is-size-4 para-title">
                  Our automated PR campaigns save your company time and money
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  🤖
                </div>
                <div className="title is-size-4 para-title">
                  Match with hundreds of journalists from our database of ~600k
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  📣
                </div>
                <div className="title is-size-4 para-title">
                  Our experts write your pitch and run an email outreach campaign for you
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section has-background-white">
          <div className="container has-text-centered is-centered clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered" id="pricing">Why Howler?</h2>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    ⚡️
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Hyper-targeted journalist outreach powered by AI</p>
                  <p className="subtitle is-size-6 is-feature-para">We match you with hundreds of journalists based on what they’ve written about before, what they've tweeted about, and where they write</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    📡
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Simple journalist outreach without spamming them</p>
                  <p className="subtitle is-size-6 is-feature-para">We generate a custom list of journalists for every campaign we run, minimizing spam and maximizing pitch-to-journalist relevance</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    🤖
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Quick, automated, no-strings-attached campaign sprints</p>
                  <p className="subtitle is-size-6 is-feature-para">Howler campaigns take minutes to start, are focused on a specific journalist niche, and are easy to cancel if the ROI isn’t there</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    📣
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Match with hundreds of journalists from our categorized database of ~600k</p>
                  <p className="subtitle is-size-6 is-feature-para">We’ve compiled a database of ~600k journalists categorized by what they’re likely to write about next</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    📊
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Comprehensive reports sent to you after every campaign</p>
                  <p className="subtitle is-size-6 is-feature-para">Reports include a list of journalists targeted and their email open & reply rates</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    🚧
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Iterative campaigns based on real journalist feedback</p>
                  <p className="subtitle is-size-6 is-feature-para">We iterate your journalist segmentation and pitch copy every month based on journalist feedback</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    📝
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Get an optimized journalist pitch hand-written by our in-house PR team</p>
                  <p className="subtitle is-size-6 is-feature-para">Our pitches are a few paragraphs long, optimized for story clarity</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    💌
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Full email outreach campaigns complete with 2 follow-ups per journalist</p>
                  <p className="subtitle is-size-6 is-feature-para">We follow up with each journalist who hasn't expressed disinterest twice</p>
                </div>
              </div>
            </div>
            <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
          </div>
        </section>

        <section className="section" id="howitworks">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">How it works</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Getting started with Howler is simple and only takes a few minutes.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  📝
                </div>
                <div className="title is-size-4 para-title">
                  1. After you subscribe we'll write your pitch, then work with you to perfect it
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  🤖
                </div>
                <div className="title is-size-4 para-title">
                  2. We’ll generate a custom list of journalists targeted to your company's niche
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  📣
                </div>
                <div className="title is-size-4 para-title">
                  3. We’ll run a 2-3 week long email campaign with 2 follow-ups per journalist
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  😍
                </div>
                <div className="title is-size-4 para-title">
                  4. When journalists reply to your story with interest, we'll introduce you directly
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  📊
                </div>
                <div className="title is-size-4 para-title">
                  5. Once your campaign is complete, we’ll send a list of journalists targeted and their open & reply rates
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="is-size-2">
                  🔁
                </div>
                <div className="title is-size-4 para-title">
                  6. We'll iterate your campaign based on journalist feedback, then repeat!
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section has-background-white">
          <div className="has-text-centered is-centered">
            <p className="is-size-6 has-text-weight-semibold used-by">We've ran campaigns for companies like:</p>
            <img
              src={ Users }
              style={{width:'100%',zIndex:'0'}}
            />
          </div>
        </section>

        <section className="section is-paddingless">
          <img
            src={ Media }
            style={{width:'100%',zIndex:'0'}}
          />
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">We've helped companies get hundreds of press features</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Our campaigns have garnered millions of impressions from outlets all over the world</p>
            </div>
            <div className="columns">
              <div className="column">
                <img
                  src={ Rumblr }
                  className="case-study-image"
                />
              </div>
              <div className="column is-para-case-study">
                <div className="title is-size-4 para-title">
                  Rumblr was featured by hundreds of media outlets in just 4 days
                </div>
                <p className="is-size-5">We used Howler’s cold emailing strategy to get the attention of journalists, helping Rumblr get featured by hundreds of media outlets like The Washington Post, The Independent, and BBC in only 4 days</p>
                <a href="https://medium.com/the-mission/how-we-hacked-the-media-and-landed-six-figure-contracts-in-four-days-96ea4aca4eef" target="_blank">
                  <div className="button is-stripe-middle">READ THE CASE STUDY</div>
                </a>
              </div>
            </div>
          </div>

          <div className="container clear-section-card">
            <div className="columns">
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://www.independent.co.uk/life-style/gadgets-and-tech/news/rumblr-tinder-for-fighting-app-website-launch-date-beta-9-november-a6727561.html" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      🥊
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      Rumblr: The 'Tinder for fighting' website that allows users to arrange real-life brawls is set for launch
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by The Independent for Rumblr</p>
                  </a>
                </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://www.cltampa.com/music/music-news/article/20999358/radiate-the-tinder-of-coachella-also-works-at-sunset-music-festival-and-wanee" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    💃
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    The "Tinder for meeting people at Coachella" also works at Sunset Music Festival and Wanee
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Creative Loafing: Tampa Bay for Radiate</p>
                </a>
              </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://mashable.com/2018/02/21/bitcoin-regret-club/#LRdfkjVTyOqN" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    💸
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    This might be the most depressing website ever made
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Mashable for Bitcoin Regret Club</p>
                </a>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://www.gonzagabulletin.com/news/article_b2319aba-2d46-11e8-9677-8333f5900a42.html" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    📣
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    March for Our Lives takes to the streets of Spokane this Saturday
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by The Gonzaga Bulletin for Betterplace</p>
                </a>
              </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://www.stuff.tv/hot-stuff/tablets-computers/pureshape-minimalist-mousepad-apples-magic-mouse-inspired-dieter-rams" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    💻
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    PureShape is a minimalist mousepad for Apple’s Magic Mouse, inspired by Dieter Rams
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Stuff for PureShape</p>
                </a>
              </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://gameranx.com/features/id/141839/article/bacon-man-an-adventure-impressions-sizzling-porky-goodness/" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    🐷
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    Bacon Man: An Adventure Impressions—Sizzling Porky Goodness
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Gameranx for Bacon Man: An Adventure</p>
                </a>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://www.makeuseof.com/tag/gmail-message-ids-specific-emails/" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    💌
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    How to Bookmark Individual Emails Using Gmail Message IDs
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by MakeUseOf for Gmail Message ID Finder</p>
                </a>
              </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="http://www.iheartradio.ca/cjay92/trending/this-pool-sharing-site-is-genius-and-we-need-it-in-calgary-1.7383857" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    🏊
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    This Pool Sharing Site Is Genius and We Need It in Calgary
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by iHeartRadio for Swimply</p>
                </a>
              </div>
              <div className="column is-hiw-card is-sample-card">
                <a className="no-styling" href="https://observer.com/2016/02/how-rumblrs-marketing-agency-gamed-the-media-for-100k-in-business/" target="_blank">
                  <div className="is-size-2 has-padding-bottom">
                    🏴
                  </div>
                  <div className="subtitle is-size-5 has-text-weight-bold">
                    How Rumblr’s Marketing Agency Gamed the Media for $100k in Business
                  </div>
                  <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Observer for von Hughes</p>
                </a>
              </div>
            </div>
            <div className="is-centered has-text-centered" style={{marginTop:'2em'}}>
              <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
            </div>

          </div>
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">Our users love us</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Our campaigns have garnered millions of impressions from outlets all over the world</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "I've seen Matt and his team get millions of impressions and coverage for clients. I highly recommend their services."
                </div>
                <p className="is-size-6 has-text-weight-semibold">❤️ Founder of The Mission</p>
              </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "They did an excellent job increasing traffic to our website. We saw a major lift in both SEO and ASO after working with them."
                </div>
                <p className="is-size-6 has-text-weight-semibold">❤️ Founder of Yik Yak & The Q</p>
              </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "They saved us so much time. We concentrated on the product and let them do the hard work. We're very pleased with the results."
                </div>
                <p className="is-size-6 has-text-weight-semibold">❤️ Co-founder of Richie Invest</p>
              </div>
            </div>
            <p className="subtitle is-size-6 has-text-centered is-centered feedback-subtitle has-text-weight-semibold">REAL FEEDBACK FROM A SUBSCRIBER</p>
            <div className="columns">
              <div className="column is-email-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                Matt/Frances,<br /><br />
                Thanks for your hard work. I did get this interview on the Mike Koolidge show, which I guess is going to be broadcast later today to thousands of people? It's hard to tell what's happening on live radio.<br /><br />
                But Mike had some feedback for you. He said something like:<br /><br />
                "You know I get tons of emails from people wanting to be a guest on the show and they talk about themselves and how many other shows have interviewed them. But this one stood out because you personalized the email and used Mike's first name, and you followed up 3 times on it." So it wasn't until that 3rd email that he clicked the link and it made him interested.<br /><br />
                This kind of persistence is NOT something I could do on my own. So thanks for your hard work on it.<br /><br />
                That's the first win! Yay! Also I have the BBC interview setup for Thursday. So we'll see what happens then!<br /><br />
                -Jack
                </div>
              </div>
            </div>
            <div className="is-centered has-text-centered" style={{marginTop:'2em'}}>
              <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
            </div>
          </div>
        </section>

          <section className="section">
            <div className="container has-text-centered is-centered">
              <div className="pricing-head has-text-centered is-centered has-text-black">
                <h2 className="title section-title has-text-centered is-centered">Our team 🗽</h2>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Matt }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Matt Henderson</p>
                    <p className="is-size-6">
                    <b>Co-founder</b> • Growth hacker & designer featured by over 200 media outlets for projects like Rumblr and von Hughes<br /><br />
                    </p>
                  </div>
                </div>
                <div className="column">
                  <div className="has-text-centered">
                    <div>
                      <img
                      src= { Aaron }
                      style= {{height:"5em"}}
                      />
                    </div>
                    <p className="has-text-weight-bold is-size-4 person-title">Aaron Tsai</p>
                    <p className="is-size-6">
                    <b>Co-founder</b> • Full-stack software engineer, Co-founder of Athena AI, ex-cancer researcher at UCSD<br /><br />
                    </p>
                  </div>
                </div>
              </div>
              </div>
            </section>

            <section className="section" id="FAQ">
              <div className="container clear-section-card-writing-samples">
                <div className="pricing-head has-text-centered is-centered has-text-black">
                  <h2 className="title has-text-centered is-centered">FAQ</h2>
                  <p className="subtitle has-text-centered is-centered pricing-sub">If our FAQ doesn't answer your questions, please reach out to us in our live chat in the bottom right.</p>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      What is your conversion rate?
                    </div>
                    <p className="is-size-6">Our conversion rate on journalist interest fluctuates between 1% and 2%. We define journalist interest as positive sentiment to outreach emails we send and introductions to the subscriber.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      Do you guarantee press?
                    </div>
                    <p className="is-size-6">Unfortunately we can’t guarantee press. Howler is a simple outreach tool to get in front of relevant journalists quickly and maximize your chances of getting featured. We don’t offer refunds if you don’t get featured. By subscribing to Howler, you acknowledge you understand this.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      How many campaigns should I run with Howler?
                    </div>
                    <p className="is-size-6">We recommend using Howler for 3-5 months, but you don’t have to if you aren’t seeing the results you’d like.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      Can you get me featured in a non-English media outlet?
                    </div>
                    <p className="is-size-6">We’re focused on English-speaking outlets. However, non-English outlets often seed a lot of their content from English outlets, then translate. Running a campaign with Howler doesn’t exclude you from this possible.</p>
                  </div>
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      Aren’t you spamming journalists?
                    </div>
                    <p className="is-size-6">No. We actually reduce journalist spam by matching pitches to only relevant journalists. Our algorithms aren’t perfect, but they’re dramatically better than just blanket emailing static email lists you buy on the internet for a thousand bucks.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      What if I don’t get press?
                    </div>
                    <p className="is-size-6">It might not be the right time. The most important thing in a press pitch is the catalyst: “Why is now the right time to share this story with my audience?” If you have a compelling answer to that question, we suggest iterating your campaign and trying again. If not, take a step back and reconsider why you’re pursuing press in the first place.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      How accurate are the lists you generate?
                    </div>
                    <p className="is-size-6">Depending on the size of the list 60-80% of the journalists are relevant. We’re working on optimizing our matching algos to make this better. It’s a pretty challenging technical problem we intend to spend a few years perfecting.</p>
                  </div>
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      How long do campaigns last?
                    </div>
                    <p className="is-size-6">One Howler campaign lasts around 1 month, depending on how quickly you approve the initial pitch we write for you.</p>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-hiw-card">
                    <div className="title is-size-5">
                      Can I see an example of a pitch you’ve written?
                    </div>
                    <p className="is-size-6">Yes, ask for an example in our live chat to the right and we’ll send you some.</p>
                  </div>
                  <div className="column is-hiw-card" style={{opacity:'0'}}>
                    <div className="title is-size-5">

                    </div>
                    <p className="is-size-6"></p>
                  </div>
                </div>
              </div>
            </section>

        <Footer />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/homepage.js